 (function() {
	'use strict';
	const ClickyMenus = function( menu ) {

		// DOM element(s)
		let	container = menu.parentElement.parentElement,
			currentMenuItem,
			i,
			len;

		this.init = function() {
			menuSetup();
			document.addEventListener( 'click', closeOpenMenu );
		}

		function toggleOnMenuClick( e ) {
			document.querySelector('predictive-search').close();

			const button = e.currentTarget;
			// close open menu if there is one
			if ( currentMenuItem && button !== currentMenuItem ) {
				toggleSubmenu( currentMenuItem );
			}
			toggleSubmenu( button );
		}

		function toggleSubmenu( button ) {
			const submenu = document.getElementById( button.getAttribute( 'aria-controls' ) );
			if ( 'true' === button.getAttribute( 'aria-expanded' ) ) {
				button.setAttribute( 'aria-expanded', false );
				submenu.setAttribute( 'aria-hidden', true );
				currentMenuItem = false;
			} else {
				button.setAttribute( 'aria-expanded', true );
				submenu.setAttribute( 'aria-hidden', false );
				preventOffScreenSubmenu( submenu );
				currentMenuItem = button;
			}
		}

		function preventOffScreenSubmenu( submenu ) {
			const screenWidth =	window.innerWidth ||
					document.documentElement.clientWidth ||
					document.body.clientWidth,
					parent = submenu.offsetParent,
					menuLeftEdge = parent.getBoundingClientRect().left,
					menuRightEdge = menuLeftEdge + submenu.offsetWidth;
			if ( menuRightEdge + 32 > screenWidth ) { // adding 32 so it's not too close
				submenu.classList.add( 'sub-menu--right' );
			}
		}

		function closeOnEscKey(e) {
			if(	27 === e.keyCode ) {
				// we're in a submenu item
				if( null !== e.target.closest('ul[aria-hidden="false"]') ) {
					currentMenuItem.focus();
					toggleSubmenu( currentMenuItem );
				// we're on a parent item
				} else if ( 'true' === e.target.getAttribute('aria-expanded') ) {
					toggleSubmenu( currentMenuItem );
				}
			}
		}

		function closeOpenMenu( e ) {
			let selector = '#' + container.id;
			if ( currentMenuItem && ! e.target.closest( selector ) ) {
				toggleSubmenu( currentMenuItem );
			}
		}

		function menuSetup() {

			menu.classList.remove('no-js');
			menu.querySelectorAll('ul').forEach( ( submenu ) => {
				const menuItem = submenu.parentElement;
				if ( 'undefined' !== typeof submenu ) {
					let button = convertLinkToButton( menuItem );
					setUpAria( submenu, button );
					// bind event listener to button
					button.addEventListener( 'click', toggleOnMenuClick );
					menu.addEventListener( 'keyup', closeOnEscKey );
				}
			});
		}

		function convertLinkToButton( menuItem ) {
			const 	link = menuItem.getElementsByTagName( 'a' )[0],
					linkHTML = link.innerHTML,
					linkAtts = link.attributes,
					button = document.createElement( 'button' );
			if( null !== link ) {
				// set button content and attributes
				button.innerHTML = linkHTML.trim();
				for( i = 0, len = linkAtts.length; i < len; i++ ) {
					let attr = linkAtts[i];
					if( 'href' !== attr.name ) {
						button.setAttribute( attr.name, attr.value );
					}
				}
				menuItem.replaceChild( button, link );
			}
			return button;
		}

		function setUpAria( submenu, button ) {
			const submenuId = submenu.getAttribute( 'id' );
			let id;
			if( null === submenuId ) {
				id = button.textContent.trim().replace(/\s+/g, '-').toLowerCase() + '-submenu';
			} else {
				id = menuItemId + '-submenu';
			}
			// set button ARIA
			button.setAttribute( 'aria-controls', id );
			button.setAttribute( 'aria-expanded', false );
			// set submenu ARIA
			submenu.setAttribute( 'id', id );
			submenu.setAttribute( 'aria-hidden', true );
		}
	}

	/* Create a ClickMenus object and initiate menu for any menu with .clicky-menu class */
	document.addEventListener('DOMContentLoaded', function(){
		const menus = document.querySelectorAll( '.click-menu' );
		menus.forEach( menu => {
			let clickyMenu = new ClickyMenus(menu);
			clickyMenu.init();
		});
	});
}());

//mobile navigation toggle

let navToggle = document.getElementById('menuToggle')
let navDrawer = document.getElementById('mobileDrawer')
let siteNav = document.getElementById('siteNavigation')
let navRight = document.querySelectorAll('.nav-right')

const toggleNav = () => {
  navToggle.classList.toggle('open')
  navDrawer.classList.toggle('open')
  siteNav.classList.toggle('open')
  navRight.forEach(element => {
    element.classList.toggle('light')
  });
}

if (navToggle) {
	navToggle.addEventListener('click', toggleNav)
}

// Navigation styles

const header = document.querySelector('[data-header]')
const sections = [...document.querySelectorAll('[data-section]')]

const headerObserver = new IntersectionObserver((entries, observer) => {
	entries.forEach( (entry) => {
		if (entry.isIntersecting) {
			header.setAttribute('data-theme', entry.target.dataset.section);
		} else {
			if (entries.length === 1)
				header.setAttribute('data-theme', 'light');
		}
	});
}, {
	rootMargin: '-' + header.clientHeight + 'px 0px -' + (window.innerHeight - header.clientHeight) + 'px 0px',
	threshold: 0
});

sections.forEach((section) => {
	headerObserver.observe(section)
})

function updateHeaderAndAnnouncementHeight() {
	const header = document.querySelector('[data-header]');
	const announcementBar = document.querySelector('.announcement-bar');
	
	let headerHeight = 0;
	let announcementHeight = 0;

	if (header) {
		headerHeight = header.offsetHeight;
	}

	if (announcementBar) {
		announcementHeight = announcementBar.offsetHeight;
	}

	// Set the CSS variables
	document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
	document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
}

window.addEventListener('DOMContentLoaded', updateHeaderAndAnnouncementHeight);
window.addEventListener('resize', updateHeaderAndAnnouncementHeight);